import { PreLoginTitleBar, TitleBar } from 'components';
import { TITLE_BAR_HEIGHT_PX } from 'components/navbars/TitleBar.styles';
import { useMe } from 'hooks/auth';
import { useAuth } from 'providers/AuthProvider';
import { Main } from './ProtectedLayout.styles';

export default function PublicLayout({
  children,
  title,
  hasBackButton = true,
}: {
  children: React.ReactNode;
  title?: string;
  hasBackButton?: boolean;
}) {
  const { isAuthenticated } = useAuth();
  const { data: user } = useMe(isAuthenticated);
  return (
    <>
      {isAuthenticated ? (
        <TitleBar
          firstName={user?.firstName}
          lastName={user?.lastName}
          title={title}
          hasBackButton={hasBackButton}
        />
      ) : (
        <PreLoginTitleBar title={title} hasBackButton={hasBackButton} />
      )}
      <Main
        $centered={false}
        $ambossOverlayOpen={false}
        tabIndex={-1}
        style={{ paddingTop: TITLE_BAR_HEIGHT_PX }}
      >
        {children}
      </Main>
    </>
  );
}
